"use client";

import { queueSchema } from "../../../../lib/types/schema/queue/queueSchema";
import type { UseRequestProps } from "../../../../request/hooks/useRequest";
import { useRequestMutation } from "../../../../request/hooks/useRequestMutation";

export type UseRequestQueueNextItemsProps = UseRequestProps;

export const useRequestQueueNextItems = ({
  ...props
}: UseRequestQueueNextItemsProps = {}) => ({
  mutatePost: useRequestMutation<typeof queueSchema>({
    ...props,
    mutationFnRequestProps: () => ({
      method: "POST",
      schema: queueSchema,
      urlBackendPath: "/queue/next-items",
    }),
  }),
});
